import React from 'react';
import { FormattedMessage } from 'react-intl';

import { Icon } from 'shared/components';

import theme from './AppointmentsNoResultsPlaceholder.scss';

const AppointmentsNoResultsPlaceholder = () => (
  <div className={ theme.root }>
    <Icon className={ theme.icon } name="magnifier" />
    <FormattedMessage
      id="General.NoResults"
      defaultMessage="** No results found"
    />
  </div>
);

export default AppointmentsNoResultsPlaceholder;
